import { gql } from '@apollo/client';

export const CREATE_PUBLIC_WISHLIST_ID = gql`
  mutation CreatePublicWishlistId(
    $privateWishlistId: String!
    $ownerId: String!
  ) {
    createPublicWishlistId(
      privateWishlistId: $privateWishlistId
      ownerId: $ownerId
    ) {
      publicWishlistId
    }
  }
`;

export const GET_WISHLIST_DETAILS = gql`
  query GetWishlistDetails($publicWishlistId: String!) {
    getWishlistDetails(publicWishlistId: $publicWishlistId) {
      skus
      ownerFirstName
      title
    }
  }
`;
